import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';
import Buefy from 'buefy';

export default {
  all() {
    return (
      Firebase.firestore()
        .collection('queries')
        .get()
        .then(docs => {
          return Firestore.getCollectionData(docs);
        })
    );
  },


  manageUser(user) {
    const {
      code,
      gst,
      area,
      name,
      state,
      city,
      pincode,
     mobile,
      email,
      address,
      owner,
      website,
      pan_img = null,
      profile_img = null,
      active = false,
      role = "agent"
    } = user;

    const userObj = {
      code,
      gst,
      area,
      name,
      state,
      city,
      pincode,
      owner,
      mobile,
      address,
      email,
      website,
      pan_img,
      profile_img,
      active,
      role
    };
    console.log(userObj);
    const promise = user.docId
      ? Firebase.firestore()
          .collection('queries')
          .doc(user.docId)
          .update(userObj)
      : Firebase.firestore()
          .collection('queries')
          .add(userObj);

    return promise;
  },

  deleteUser(user) {
    return Firebase.firestore()
      .collection('queries')
      .doc(user)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/quries/service.js